/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTriangleCuteFi: {
  name: 'triangle-cute-fi';
  data: string;
} = {
  name: 'triangle-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.3 2.7c-1.334.252-2.469 1.252-3.878 3.415-.441.676-1.593 2.588-2.282 3.785-2.627 4.566-3.292 6.164-3.207 7.7a3.684 3.684 0 0 0 1.979 3.07c.797.421 1.865.656 3.508.77 1.768.123 7.392.123 9.16 0 1.233-.086 2.162-.244 2.857-.487 1.022-.358 1.804-1.018 2.237-1.889.795-1.598.467-3.204-1.334-6.52-1.105-2.036-3.003-5.275-3.789-6.468-1.088-1.651-1.939-2.552-2.852-3.022A3.737 3.737 0 0 0 11.3 2.7"/></svg>`
};
